(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ntd-shop-help"] && !Shopify.designMode) return;
  try {
    (() => {
    const init = () => {
      const popup = document.querySelector('[data-ntd-newsletter-popup]');
      const help = document.querySelector('[data-ntd-help-dialog]');
      const openHelp = document.querySelector('[data-ntd-help-open]');
      const key = 'ntd-newsletter-dismissed-until';
      let previousFocus;
      let prompted = false;
      const readDismissal = () => { try { return Number(localStorage.getItem(key)) || 0; } catch { return 0; } };
      const rememberDismissal = () => { try { localStorage.setItem(key, String(Date.now() + 7 * 86400000)); } catch {} };
      const open = dialog => {
        if (!dialog || dialog.open || typeof dialog.showModal !== 'function') return;
        if (document.querySelector('dialog[open]')) return;
        previousFocus = document.activeElement;
        dialog.showModal();
      };
      for (const dialog of [popup, help].filter(Boolean)) {
        if (dialog.dataset.ntdReady) continue;
        dialog.dataset.ntdReady = 'true';
        dialog.querySelector('[data-ntd-dialog-close]')?.addEventListener('click', () => dialog.close());
        dialog.addEventListener('close', () => {
          if (dialog === popup) rememberDismissal();
          if (previousFocus?.isConnected) previousFocus.focus({preventScroll: true});
        });
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        });
      }
      if (openHelp && !openHelp.dataset.ntdReady) {
        openHelp.dataset.ntdReady = 'true';
        openHelp.hidden = false;
        openHelp.addEventListener('click', () => open(help));
      }
      const signupOpen = help?.querySelector('[data-ntd-signup-open]');
      if (signupOpen && !signupOpen.dataset.ntdReady) {
        signupOpen.dataset.ntdReady = 'true';
        signupOpen.addEventListener('click', () => { help.close(); open(popup); });
      }
      if (!popup || popup.dataset.ntdPromptReady) return;
      popup.dataset.ntdPromptReady = 'true';
      if (popup.querySelector('[data-ntd-signup-feedback]')) { prompted = true; open(popup); return; }
      if (popup.hasAttribute('data-subscribed') || document.documentElement.classList.contains('shopify-design-mode')) return;
      const started = Date.now();
      const prompt = () => {
        if (prompted || Date.now() < readDismissal() || document.hidden || Date.now() - started < 12000) return;
        if (document.querySelector('dialog[open]') || document.activeElement?.matches('input,textarea,select')) return;
        open(popup);
        if (popup.open) { prompted = true; rememberDismissal(); }
      };
      setTimeout(prompt, 25000);
      document.addEventListener('mouseout', event => {
        if (!event.relatedTarget && event.clientY <= 0 && window.matchMedia('(pointer:fine)').matches) prompt();
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
    else init();
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

})();
